<div class="w-full" #pageContainer>
    <div class="bg-card shadow rounded-2xl p-5 m-4">
        <div class="flex font-medium items-center justify-between mb-6 text-2xl tracking-tight">
            Activity Overview
            <button class="btn btn-outline btn-default" style="float: inline-end"
                [routerLink]="['/data-management/daily-activity-tracker']">
                Daily Activity Tracker
            </button>
        </div>
        <div class="w-full grid grid-cols-1">
            <form [formGroup]="searchForm">

                <app-table-filter [searchForm]="searchForm" class="text-primary"
                    (searchTriggered)="handleSearch($event)">
                </app-table-filter>

                <div class="grid grid-cols-1 sm:grid-cols-3">
                    <div class="col-span-2 flex justify-start">
                        <div class="w-19 ml-2">
                            <mat-form-field class="w-full no-bottom-gap mb-2">
                                <mat-select formControlName="PageSize">
                                    <mat-option [value]="10"> 10 </mat-option>
                                    <mat-option [value]="20"> 20 </mat-option>
                                    <mat-option [value]="50"> 50 </mat-option>
                                    <mat-option [value]="100"> 100 </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div>
                            <mat-form-field class="w-56 ml-2 no-bottom-gap mb-2">
                                <input matInput formControlName="activityDate" [matDatepicker]="picker"
                                    placeholder="Select Activity Date"/>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        
                        <app-sort-menu class="mx-2" [columns]="columnSort" [orderDir]="'asc'" [initialOrderKeys]="[]"
                            (apply)="applySort($event)">
                        </app-sort-menu>

                        <button class="btn btn-outline btn-default dt-download" matTooltip="Download Records"
                            [matMenuTriggerFor]="downloadMenu">
                            <mat-icon class="text-primary hover:text-white"
                                svgIcon="heroicons_solid:arrow-down-tray"></mat-icon>
                        </button>
                        <mat-menu #downloadMenu="matMenu">
                            <button mat-menu-item (click)="downloadExcel()">Excel</button>
                        </mat-menu>
                    </div>
                    <div class="flex justify-end">
                        <button class="btn btn-primary mx-2" (click)="setPage({ offset: 0 })">
                            Search
                        </button>
                        <button class="btn btn-outline btn-default" (click)="reset()">
                            Reset
                        </button>
                        <button class="btn btn-outline btn-default mx-2 hover:text-white" matTooltip="Refresh Table"
                            (click)="setPage({ offset: dt.page.offset })">
                            <mat-icon class="text-primary hover:text-white"
                                svgIcon="heroicons_solid:arrow-path"></mat-icon>
                        </button>
                    </div>

                    <div class="flex justify-start col-span-2">
                        <span class="self-center font-medium text-gray-400 italic text-md p-2">
                            Sorting by {{ sortInfo }}
                        </span>
                    </div>

                    <div class="flex justify-end">
                        <span class="self-center font-medium text-primary text-md p-2">
                            {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'record' : 'records' }}
                                </span>
                    </div>
                </div>
            </form>

            <div class="grid overflow-x-auto">
                <!-- Header -->
                <div class="table-activity-overview-record-grid z-10 sticky top-0 grid shadow text-md font-semibold text-white bg-primary dark:bg-black dark:bg-opacity-5"
                    matSort matSortDisableClear>
                    <div class="border py-8 text-center">
                        No
                    </div>

                    <div [mat-sort-header]="'fieldLongName'"
                        class="flex justify-center border py-4 my-custom-sort-header">
                        Field
                    </div>

                    <div [mat-sort-header]="'platformLongName'" class="flex justify-center border py-4">
                        Platform
                    </div>

                    <div [mat-sort-header]="'wellLongName'" class="flex justify-center border py-4">
                        Well
                    </div>

                    <div [mat-sort-header]="'stringShortName'" class="flex justify-center border py-4">
                        Well String
                    </div>

                    <div [mat-sort-header]="'stringIndicatorShortName'" class="flex border justify-center py-4">
                        String Indicator
                    </div>

                    <div [mat-sort-header]="'activityDate'" class="flex border justify-center py-4">
                        Activity Date
                    </div>

                    <div [mat-sort-header]="'activityType'" class="flex border justify-center py-4">
                        Activity Type
                    </div>

                    <div [mat-sort-header]="'dailyActivity'" class="flex border justify-center py-4">
                        Daily Activity
                    </div>

                </div>
                <!-- Rows -->
                <ng-container *ngIf="dt.rows.length; else noRecords">
                    <ng-container *ngFor="let row of dt.rows; let i = index; trackBy: trackByFn;">
                        <div class="table-activity-overview-record-grid  grid items-center border-b"
                            [ngClass]="{'bg-primary-100': i % 2 }">

                            <!-- No -->
                            <div class="py-4 text-center">
                                {{startingIndex + i + 1}}.
                            </div>

                            <!-- Field Long Name -->
                            <div class="flex truncate justify-center">
                                {{ row.fieldLongName }}
                            </div>

                            <!-- Platform Long Name  -->
                            <div class="flex justify-center">
                                {{ row.platformLongName }}
                            </div>

                            <!-- Well Long Name  -->
                            <div class="flex justify-center">
                                {{ row.wellLongName }}
                            </div>

                            <!-- String Short Name  -->
                            <div class="text-center">
                                {{ row.stringShortName }}
                            </div>

                            <!-- String Indicator -->
                            <div class="block text-center">
                                {{ row.stringIndicatorShortName }}
                            </div>

                            <!--  Activity Date -->
                            <div class="block text-center mx-2">
                                {{ handleFormatDate(row.activityDate,false) || '-' }}
                            </div>

                            <!-- Activity Type -->
                            <div class="block text-center">
                                {{ row.activityType || '-' }}
                            </div>

                            <!-- Daily Activity -->
                            <div class="block mx-2 py-2">
                                {{ row.dailyActivity || '-' }}
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-template #noRecords>
                    <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
                        There are no records registered!
                    </div>
                </ng-template>


                <ng-template #noDailyActivity>
                    <div>
                        -
                    </div>
                </ng-template>
            </div>

            <div
                class="flex justify-between inset-x-0 bottom-0 border-b border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent">
                <div class="content-center px-3">
                    {{ dt.page.totalRecords || 0 }} {{ dt.page.totalRecords <= 1 ? 'total' : 'totals' }} </div>

                        <mat-paginator class="bg-gray-50" [ngClass]="{'pointer-events-none': isLoading}"
                            [length]="dt.page?.totalRecords" [pageIndex]="dt.page.offset" [pageSize]="dt.page.size"
                            [hidePageSize]="true" [showFirstLastButtons]="true">
                        </mat-paginator>
                </div>
            </div>
        </div>
    </div>

    <ng-template #closedIcon>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
    </ng-template>